const DEFAULT_MAX_LENGTH = 10;

export const truncateString = (string = '', length = DEFAULT_MAX_LENGTH) => {
  return `${string.substring(0, length)}${string.length > length ? '...' : ''}`;
};
